<div style="display: inline-block" >
    <div fxLayout="column" >
      <mat-icon [title]="titleLayers" (click)="switchVisibleLayerSelection()" cdkOverlayOrigin #trigger="cdkOverlayOrigin" [ngClass]="isOpen ? 'layer-icon active' : 'layer-icon'">
        layers
      </mat-icon>
      <mat-icon *ngIf="isVisible" [title]="titleVisible" (click)="switchVisibleParentLayer()"  [ngClass]="'layer-icon'">
        visibility
      </mat-icon>
      <mat-icon *ngIf="!isVisible" [title]="titleVisibleOff" (click)="switchVisibleParentLayer()"  [ngClass]="'layer-icon'">
        visibility_off
      </mat-icon>
      <mat-icon *ngIf="lsService.getShowLegendsButton()" [title]="titleLegendVisible" (click)="switchVisibleLegend()" [ngClass]="isLegendVisible ? 'layer-icon active' : 'layer-icon'">
        legend_toggle
      </mat-icon>
      <mat-icon *ngIf="lsService.getshowMeasureButton()" [title]="isMeasureVisible ? titleMeasureStop : titleMeasureStart" (click)="switchVisibleMeasure()" [ngClass]="isMeasureVisible ? 'layer-icon active' : 'layer-icon'">
        square_foot
      </mat-icon>
      <div *ngIf="!lsService.getShowLegendsButton()" style="height: 24px;">

      </div>
    </div>

    <!-- This template displays the overlay content and is connected to the button -->
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="isOpen"
      ConnectedPositioningStrategy
      ScrollStrategyOptions="reposition"
        >
    <div fxLayout="column" fxLayoutAlign="space-around center"  class="layer-dropdown">
      <app-baselayer-dropdown [ngStyle]="{
        'width.px': 275,
        'margin-bottom.px': 15
      }"></app-baselayer-dropdown>
      <app-layer-control></app-layer-control>
    </div>
    </ng-template>

  </div>

